module.exports = __webpack_public_path__ + "img/announcement-megaphone-green.a6c37f51.svg";